import React from 'react'
import { connect } from 'react-redux'
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog'
import { acceptConfirm, cancelConfirm } from '@chegg-wt/redux-citation-api'
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button'

const ConfirmDialog = ({visible, title, content, handleAgree, handleCancel}) =>
  <Dialog
    hidden={ !visible }
    dialogContentProps={ {
      type: DialogType.normal,
      title: title,
      subText: content
    } }
    modalProps={ {
      isBlocking: true,
      containerClassName: 'ms-dialogMainOverride'
    } }
  >
    <DialogFooter>
      <PrimaryButton onClick={ handleAgree } text='Confirm' />
      <DefaultButton onClick={ handleCancel} text='Cancel' />
    </DialogFooter>
  </Dialog>
const mapStateToProps = (state) => ({
  visible: state.confirm.visible,
  title: state.confirm.title,
  content: state.confirm.message,
})

const mapDispatchToProps = (dispatch) => ({
  handleAgree: () => {
    dispatch(acceptConfirm())
  },
  handleCancel: () => {
    dispatch(cancelConfirm())
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmDialog)



// WEBPACK FOOTER //
// ./src/ConfirmDialog.js